import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "SensitivityGAP" })((_theme) => ({
  page: {
    margin: "20px",
  },
  sensitivityGAPExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "-30px",
  },
}));
